// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.legendWrapper--O8hxa {
  display: flex;
  font-family: museo-sans;
  justify-content: center;
}[dir] .legendWrapper--O8hxa {
  margin: 20px auto !important;
}

[dir=ltr] .legendTitle--mgW8W {
  margin-right: 15px;
}

[dir=rtl] .legendTitle--mgW8W {
  margin-left: 15px;
}

.itemWrapper--NYZmm {
  display: flex;
  align-items: center;
}

[dir] .itemWrapper--NYZmm {
  margin: 0 10px;
}

.indicator--WG3Iw {
  width: 20px;
  height: 20px;
}

[dir=ltr] .indicator--WG3Iw {
  margin-right: 5px;
}

[dir=rtl] .indicator--WG3Iw {
  margin-left: 5px;
}

[dir] .lowest--yYnji {
  background-color: #df1258;
}

[dir] .highest--Te4SK {
  background-color: #d1df12;
}

[dir] .highlights--gjuHw {
  background-color: rgba(199, 252, 255, 1);
}

.groupHighlight--vzKNl {
  width: 4px;
}

[dir] .groupHighlight--vzKNl {
  background-color: #04febb;
}

[dir] .positiveChange--sOeIO {
  background-color: rgb(206, 224, 174);
}

[dir] .negativeChange--gipd5 {
  background-color: rgb(223, 170, 170);
}

[dir] .trimmed--YqoSp {
  border: rgb(172, 172, 172) 3px solid;
}

[dir] .estimated--t9ipN {
  border: rgb(166, 158, 76) 3px solid;
}

[dir] .trimmed-estimated--UQ3qq {
  border: rgb(29, 90, 119) 3px solid;
}

.strikeout--fUfsG {
  text-decoration: line-through;
}

.infoIcon--eDblH {
  width: 17px;
  height: 17px;
}

[dir] .infoIcon--eDblH {
  margin-top: 2px;
}

[dir=ltr] .infoIcon--eDblH {
  margin-left: 5px;
}

[dir=rtl] .infoIcon--eDblH {
  margin-right: 5px;
}

.customGroupIcon--Zztl2 {
  width: 18px;
  height: 18px;
  vertical-align: middle;
}

[dir=ltr] .customGroupIcon--Zztl2 {
  margin-right: 5px;
}

[dir=rtl] .customGroupIcon--Zztl2 {
  margin-left: 5px;
}

/* Grey pill around a custom group's icon + name (swatch stays outside),
   matching the chart legends and the .custom-group-name title styling. */
.customGroupPill--YuFjz {
  display: inline-flex;
  align-items: center;
}
[dir] .customGroupPill--YuFjz {
  padding: 2px 8px;
  background-color: #e4e4e4;
  border-radius: 5px;
}
[dir=ltr] .customGroupPill--YuFjz {
  margin-left: 5px;
}
[dir=rtl] .customGroupPill--YuFjz {
  margin-right: 5px;
}
`, "",{"version":3,"sources":["webpack://./src/js/components/TableFooterLegend/styles.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EAEb,uBAAuB;EACvB,uBAAuB;AACzB,CALA;EAEE,4BAA4B;AAG9B;;AAEA;EACE,kBAAkB;AACpB;;AAFA;EACE,iBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;AAErB;;AAJA;EAGE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;AAEd;;AAJA;EAGE,iBAAiB;AACnB;;AAJA;EAGE,gBAAiB;AACnB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EAEE,UAAU;AACZ;;AAHA;EACE,yBAAyB;AAE3B;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EAGE,WAAW;EACX,YAAY;AACd;;AALA;EAEE,eAAe;AAGjB;;AALA;EACE,gBAAgB;AAIlB;;AALA;EACE,iBAAgB;AAIlB;;AAEA;EACE,WAAW;EACX,YAAY;EAEZ,sBAAsB;AACxB;;AALA;EAGE,iBAAiB;AAEnB;;AALA;EAGE,gBAAiB;AAEnB;;AAEA;yEACyE;AACzE;EACE,oBAAoB;EACpB,mBAAmB;AAKrB;AAPA;EAIE,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;AACpB;AAPA;EAGE,gBAAgB;AAIlB;AAPA;EAGE,iBAAgB;AAIlB","sourcesContent":[".legendWrapper {\n  display: flex;\n  margin: 20px auto !important;\n  font-family: museo-sans;\n  justify-content: center;\n}\n\n.legendTitle {\n  margin-right: 15px;\n}\n\n.itemWrapper {\n  display: flex;\n  align-items: center;\n  margin: 0 10px;\n}\n\n.indicator {\n  width: 20px;\n  height: 20px;\n  margin-right: 5px;\n}\n\n.lowest {\n  background-color: #df1258;\n}\n\n.highest {\n  background-color: #d1df12;\n}\n\n.highlights {\n  background-color: rgba(199, 252, 255, 1);\n}\n\n.groupHighlight {\n  background-color: #04febb;\n  width: 4px;\n}\n\n.positiveChange {\n  background-color: rgb(206, 224, 174);\n}\n\n.negativeChange {\n  background-color: rgb(223, 170, 170);\n}\n\n.trimmed {\n  border: rgb(172, 172, 172) 3px solid;\n}\n\n.estimated {\n  border: rgb(166, 158, 76) 3px solid;\n}\n\n.trimmed-estimated {\n  border: rgb(29, 90, 119) 3px solid;\n}\n\n.strikeout {\n  text-decoration: line-through;\n}\n\n.infoIcon {\n  margin-left: 5px;\n  margin-top: 2px;\n  width: 17px;\n  height: 17px;\n}\n\n.customGroupIcon {\n  width: 18px;\n  height: 18px;\n  margin-right: 5px;\n  vertical-align: middle;\n}\n\n/* Grey pill around a custom group's icon + name (swatch stays outside),\n   matching the chart legends and the .custom-group-name title styling. */\n.customGroupPill {\n  display: inline-flex;\n  align-items: center;\n  margin-left: 5px;\n  padding: 2px 8px;\n  background-color: #e4e4e4;\n  border-radius: 5px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"legendWrapper": `legendWrapper--O8hxa`,
	"legendTitle": `legendTitle--mgW8W`,
	"itemWrapper": `itemWrapper--NYZmm`,
	"indicator": `indicator--WG3Iw`,
	"lowest": `lowest--yYnji`,
	"highest": `highest--Te4SK`,
	"highlights": `highlights--gjuHw`,
	"groupHighlight": `groupHighlight--vzKNl`,
	"positiveChange": `positiveChange--sOeIO`,
	"negativeChange": `negativeChange--gipd5`,
	"trimmed": `trimmed--YqoSp`,
	"estimated": `estimated--t9ipN`,
	"trimmed-estimated": `trimmed-estimated--UQ3qq`,
	"strikeout": `strikeout--fUfsG`,
	"infoIcon": `infoIcon--eDblH`,
	"customGroupIcon": `customGroupIcon--Zztl2`,
	"customGroupPill": `customGroupPill--YuFjz`
};
export default ___CSS_LOADER_EXPORT___;
